export const endpointsToExcludeTheJWT = [
  "auth/login/",
  "auth/register/",
  "auth/forget_password/",
  "auth/reset_password/",
  "auth/token/refresh/",
];

// Calls that set, read or clear the HttpOnly refresh-token cookie, so they must
// send and accept cookies. Every other call keeps using the Bearer header only.
export const endpointsUsingAuthCookies = [
  "auth/login/",
  "auth/register/",
  "auth/reset_password/",
  "auth/token/refresh/",
  "auth/password/change/",
  "auth/logout/",
  "auth/social/",
  "shop_login/",
];
